import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { intialPageSize, dateFnsFormat } from 'constants';
import { format } from 'date-fns';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { pageSizeChangeHandler } from 'utils/commonUtils';

const RawProgress = () => {
  const [rawProgressList, setRawProgressList] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
  });
  const { pageSize, page } = rawProgressList;

  const rawProgressInformation =
    useSelector((state) => state?.studentDetails?.item) || {};

  useEffect(() => {
    if (rawProgressInformation) {
      fetchDataCourseInformation();
    }
  }, [pageSize, page, rawProgressInformation]);

  const fetchDataCourseInformation = () => {
    setRawProgressList((previous) => ({
      ...previous,
      rows: rawProgressInformation?.rawProgressData?.data?.map(
        (item, index) => ({
          id: index,
          actualgrade: item.actualgrade,
          completedassignments: item.completedassignments,
          coursename: item.coursename,
          overallgrade: item.overallgrade,
          percentbycount: item.percentbycount,
          percentbytime: item.percentbytime,
          percentexpected: item.percentexpected,
          progressdate: format(new Date(item.progressdate), dateFnsFormat),
          relativegrade: item.relativegrade,
          studentbuildid: item.studentbuildid,
          totalassignments: item.totalassignments,
          userid: item.userid,
        })
      ),
    }));
  };

  const columns = [
    {
      headerName: 'Course Name',
      field: 'coursename',
      renderCell: renderCellExpand,
      width: 300,
    },
    { headerName: 'Actual Grade', field: 'actualgrade', width: 150 },
    { headerName: 'Overall Grade', field: 'overallgrade', width: 150 },
    {
      headerName: 'Completed Assignments',
      field: 'completedassignments',
      width: 150,
    },
    { headerName: 'Total Assignments', field: 'totalassignments', width: 150 },
    { headerName: 'Percent by Count', field: 'percentbycount', width: 150 },
    { headerName: 'Percent by Time', field: 'percentbytime', width: 150 },
    { headerName: 'Percent Expected', field: 'percentexpected', width: 150 },
    { headerName: 'Relative Grade', field: 'relativegrade', width: 150 },
    { headerName: 'Progress Date', field: 'progressdate', width: 150 },
    { headerName: 'Student Build id', field: 'studentbuildid', width: 150 },
    { headerName: 'User id', field: 'userid', width: 150 },
  ];

  const pageSizeChange = pageSizeChangeHandler(setRawProgressList);

  return (
    <>
      <DeltaDataGrid
        listData={rawProgressList}
        columns={columns}
        setListData={pageSizeChange}
      />
    </>
  );
};

export default RawProgress;
